
export const WorkingHoursColumns = () => [
  {
    Header: "Sr.No",
    accessor: "id",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
  {
    Header: "Date",
    accessor: "date",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
  {
    Header: "Working Hours",
    accessor: "working_time",
    isInfoIcon: false,
    isShortIcon: true,
    className: "text-center lemp-id",
  },
]
